/** Fraction of a box taken by its contents (1 = full); null if any content lacks facts or capacity. */
export function boxFill(contents, facts, perBox) {
    let fill = 0;
    for (const content of contents) {
        const fact = facts.get(content.article);
        if (!fact)
            return null;
        const capacity = perBox(fact.productId);
        if (capacity === null || capacity <= 0)
            return null;
        fill += content.pieces / capacity;
    }
    return fill;
}
/** Whole pieces of a product that still fit in a box filled to `fill`; never negative. */
export function roomFor(fill, perBoxOfProduct) {
    // The epsilon absorbs floating point noise (e.g. 0.7 * 10 = 6.999...).
    return Math.max(0, Math.floor((1 - fill) * perBoxOfProduct + 1e-9));
}
//# sourceMappingURL=fill.js.map